export default __webpack_public_path__ + "static/dr-usama-4261df5aa2312db4704565c106ad4355.png";